<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <a-card title="Listar Prazos de Audiometria">
    <div class="row" style="margin-bottom: 1%">
      <div class="col-md-9">
        <label for="cpf">Unidade</label>

        <div class="col" style="padding-right: 0">
          <div class="input-group input-focus">
            <a-auto-complete v-model:value="unidade.nome" style="width: 200px" @search="handleSearch" class="form-control border-left-0">
              <template v-slot:dataSource>
                <a-select-option v-for="item in unidadesFiltro" :key="item.nome" @click="onSelect(item)">
                  {{ item.nome }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="status">Status</label>
        <div class="input-group input-focus">
          <select v-model="situacao" class="form-select form-input-component">
            <option value="TODOS">Todos</option>
            <option value="ATIVO">Ativo</option>
            <option value="INATIVO">Inativo</option>
          </select>
        </div>
      </div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-4" style="margin-bottom: 0.3%">
        <button @click="pesquisar()" class="btn btn-primary" type="button"><i class="fa fa-search"> </i> Pesquisar</button>
        <button type="button" class="btn btn-primary" @click="criarNova" style="margin: 0 5px">
          <i class="fa fa-plus"> </i>
          Criar novo
        </button>
      </div>
    </div>
  </a-card>
  <br />
  <a-card>
    <a-table :dataSource="lista" :columns="columns" :pagination="paginationConfig">
      <template #situacao="{ record }">
        <a-switch :checked="record.situacao === 'ATIVO'" @change="toggleSituacao(record)" />
      </template>
      <template #prazo="{ record }">
        {{ record.prazo + ' meses' }}
      </template>
      <template #action="{ record }">
        <a title="Excluir" @click="excluirPrazoAudiometria(record)"><i class="fas fa-trash icon-trash"></i></a>
        &nbsp;&nbsp;
        <a title="Editar" @click="editarPrazoAudiometria(record)"><i class="fas fa-edit icon-edit"></i></a>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deletePrazoAudiometriaById, getListaPrazosAudiometria, createPrazoAudiometria } from '@/components/service/prazoAudiometriaService';
import { domainUPM } from '@/config/servicos-utils';

export default {
  name: 'PageListarPrazoAudiometria',
  data() {
    return {
      situacao: 'TODOS',
      unidade: { id: null, nome: null },
      unidades: [],
      unidadesFiltro: [],
      lista: [],
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Unidade',
          dataIndex: 'unidade.nome',
          key: 'unidade.nome',
          slots: { customRender: 'unidade' },
        },
        {
          title: 'Prazo',
          dataIndex: 'prazo',
          key: 'prazo',
          slots: { customRender: 'prazo' },
        },
        {
          title: 'Status',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    excluirPrazoAudiometria(record) {
      deletePrazoAudiometriaById(record.id)
        .then(() => {
          openNotification(typesNotification.success, 'prazo de audiometria excluído com sucesso.');
          this.pesquisar();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir prazo de audiometria!');
        });
    },
    editarPrazoAudiometria(record) {
      this.$router.push({ path: '/form-prazos-audiometria', query: { id: record.id } });
    },
    criarNova() {
      this.$router.push('form-prazos-audiometria');
    },
    async toggleSituacao(alimento) {
      const novoStatus = alimento.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      const novoAlimento = { ...alimento, situacao: novoStatus };
      await createPrazoAudiometria(novoAlimento);
      this.lista.find((i) => i.id == alimento.id).situacao = novoStatus;
      openNotification(typesNotification.success, 'Status do prazo de audiometria alterado com sucesso!');
    },
    async pesquisar() {
      var filtros = { unidade: this.unidade, situacao: this.situacao };
      getListaPrazosAudiometria(filtros)
        .then((r) => {
          if (r.data.length > 0) {
            this.lista = r.data;
          } else {
            openNotification(typesNotification.info, 'Nenhum registro encontrado para os dados informados na pesquisa!');
            this.lista = r.data;
          }
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de prazos de audiometria cadastrados!');
        });
    },
    onSelect(value) {
      this.unidade = { id: value.id, nome: value.nome };
    },
    async getUnidade() {
      await domainUPM().then((r) => {
        r.data.forEach((unidade) => {
          this.unidades.push({ ...unidade, nome: unidade.nome.toUpperCase() });
        });
      });
    },
    async handleSearch(value) {
      if (value.length >= 2) {
        this.unidadesFiltro = this.unidades.filter((unidade) => unidade.nome.toUpperCase().includes(value.toUpperCase()));
      } else {
        this.unidadesFiltro = [];
      }
    },
  },
  created() {
    this.pesquisar();
    this.getUnidade();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
